<app-header></app-header>
<app-slider appBlurFade></app-slider>

<h3 class="section__title" appBlurFade>Prace</h3>
<div #worksContainer id="worksSection" class="lazy__container" appBlurFade [blurFadeDelay]="0.1"></div>

<h3 class="section__title" appBlurFade>Projekty</h3>
<div #projectsContainer id="projectsSection" class="lazy__container" appBlurFade [blurFadeDelay]="0.1"></div>

<h3 class="section__title" appBlurFade>Bio</h3>
<app-bio appBlurFade [blurFadeDelay]="0.15"></app-bio>


